/*
form = {
    'name': leads_name,
    'number': leads_number,
    'number_field': number_field,
    'alert_field': alert_field,
};
*/
export function whatsapp_validation_form(form) {
    let leads_name = form['name'];
    let this_alert_field = form['alert_field'];
    let check_location_price_enable = ('check_location_price_enable' in form) ? form['check_location_price_enable'] : false;
    let check_location_price = ('check_location_price' in form) ? form['check_location_price'] : false;

    let alert = '';
    let number = whatsapp_clean_number(form);
    let invalid_number_msg = 'Harap masukkan nomor whatsapp anda dengan benar';

    if (leads_name == '') {
      alert = 'Silakan isi nama';
    }

    if (number == '') {
      alert = 'Silakan isi nomor Whatsapp';
    } else if (number.charAt(0) == 0) {
      alert = 'Nomor salah. Silakan gunakan kode negara. Contoh: 628123456789';
    }

    if (number.length < 11 || number.length > 14) {
      alert = invalid_number_msg;
    }

    if (number.substring(0, 4) == '6262') {
      alert = invalid_number_msg;
    }

    if (number.substring(0, 2) != '62') {
      alert = 'Nomor salah. Silakan gunakan kode negara. Contoh: 628123456789';
    }

    if (check_location_price_enable && check_location_price == false) {
      alert = 'Silakan ceklis pernyataan';
    }

    if (alert == '') {
      form['number_field'].val(`+${number}`);
      return true;
    }

    this_alert_field.text(alert).show();
    return false;
}

function whatsapp_clean_number(form) {
    let this_number_field = form['number_field'];
    let number = form['number'];

    // remove non numeric
    number = number.replace(/\D/g,'');

    if (number != '') {
        // change first zero
        number = change_zero_to_country_code(number);
    }

    this_number_field.val(number);

    return number;
}

function change_zero_to_country_code(number) {
    if (number.charAt(0) == 0) {
        return '62' + number.substr(1);
    } else if (number.substring(0, 2) != '62')  {
        return '62' + number;
    }

    return number;
}

export function check_telesales_valid() {
    /*

    let api_data = sessionStorage.getItem('TSWA');
    let telesales_number = document.querySelector('[name=telesales_number]').value;

    if (api_data == null || api_data == '') {
      return true;
    }

    // eslint-disable-next-line no-undef
    api_data = api_data.replace(/\D/g, '')

    if (api_data == '') {
      return true;
    }

    const is_valid = telesales_number === api_data;
    console.info(`is_telesales_valid ${telesales_number === api_data}`)

    if(!is_valid) {
      //update all [name=telesales_number]
      document.querySelectorAll('[name=telesales_number]').forEach(element => {
        element.value = api_data;
      });
      //update href value
      document.querySelectorAll('.whatsapp-link').forEach(element => {
        element.setAttribute('href', api_data);
      });

      console.info(`telesales_number updated to ${api_data}`);
    }
    return is_valid;
    */

    return true;
}

// Enquiry count tracking for OTP re-validation every 3rd enquiry
export function get_enquiry_count(phone_number) {
    const key = 'enquiry_count_' + phone_number;
    const count = localStorage.getItem(key);
    return count ? parseInt(count, 10) : 0;
}

export function increment_enquiry_count(phone_number) {
    const currentCount = get_enquiry_count(phone_number);
    const newCount = currentCount + 1;
    const key = 'enquiry_count_' + phone_number;
    localStorage.setItem(key, newCount.toString());
    return newCount;
}

export function should_require_otp(count) {
    // Require OTP on odd-numbered enquiries: 1st, 3rd, 5th, 7th, 9th...
    return count % 2 === 1;
}

export function clean_phone_number(number) {
    // Remove non-numeric chars
    number = number.replace(/\D/g,'');
    
    if (number != '') {
        // Convert to Indonesian format (62...)
        if (number.charAt(0) == 0) {
            return '62' + number.substr(1);
        } else if (number.substring(0, 2) != '62') {
            return '62' + number;
        }
    }
    return number;
}



// WEBPACK FOOTER //
// ./scripts/global/validation-form.js